import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class DueDateColumn extends Column {
    title = 'training.dueDate';
    property = 'dueAt';
    sortable = true;
    type: CellDisplay = CellDisplay.date;
}
